export const dismissStack = [];
export const addDismissStack = (props) => {
    dismissStack.push(props);
};
export const removeDismissStack = (id) => {
    const foundIdx = dismissStack.findIndex((item) => item.uniqueId === id);
    if (foundIdx === -1)
        return;
    const foundStack = dismissStack[foundIdx];
    dismissStack.splice(foundIdx, 1);
    return foundStack;
};
